import gxdbApi from './api/gxdb';
import ottoApi from './api/otto';

export const api = {
  ...gxdbApi,
  ...ottoApi,
};
